import { setType } from 'src/app/modal'
import { useAppDispatch, useAppSelector } from 'src/hooks'
import ModalTitle from '../ModalTitle'
import ModalButtons from '../ModalButtons'
import { selectSession, setName } from 'src/app/session'
import { ChangeEvent, useState } from 'react'
import Input from '../../Input'

export const SessionRenameModal = () => {
  const dispatch = useAppDispatch()
  const { name } = useAppSelector(selectSession)
  const [newName, setNewName] = useState(name || '')

  const onRename = () => {
    if (newName.length && newName !== name) {
      dispatch(setName(newName))
      dispatch(setType({ type: null }))
    }
  }

  const onCancel = () => {
    dispatch(setType({ type: null }))
  }

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setNewName(e.target.value)
  }

  return (
    <form onSubmit={onRename}>
      <ModalTitle text="Rename Session" />

      <p className="text-sm" aria-label="sessionName">
        Session Name
      </p>

      <Input onChange={onChange} value={newName} labeledBy="sessionName" />

      <ModalButtons
        firstButton={{
          name: 'Cancel',
          type: 'secondary',
          onClick: onCancel,
          htmlButtonType: 'button',
        }}
        secondButton={{
          name: 'Rename',
          type: 'primary',
          disabled: !newName.trim().length || newName === name,
          htmlButtonType: 'submit',
        }}
      />
    </form>
  )
}
